import { connect } from 'react-redux'
import { getApper, saveWaiChuBack } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getApper,
    saveWaiChuBack
}
const mapStateToProps = (state) => {
  return {
    ...state.WaiChuBackEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
